import Component from '@cell/cell-core/component/component';
import './toggle.scss';

class Toggle extends Component {
  constructor() {
    super();

    this.handleInput = this.handleInput.bind(this);
  }

  componentDidMount() {
    this.on('input', this.handleInput);
  }

  handleInput(event) {
    this.emit('input', {
      checked: event.target.checked,
    });
  }
}

customElements.define('c-toggle', Toggle);
